import ValuationRequest from '@/models/valuation/ValuationRequest';
import ValuationResponse from '@/models/valuation/ValuationResponse';
import ValuationResultType from '@/enums/valuation/ValuationResultType';

class VehicleValuationLookupService {
  private static serviceInstance: VehicleValuationLookupService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  private apiDomain: string = `${
    process.env.VUE_APP_API_PRICING
  }/api/v1/valuation/vehicle`;

  public getVehicleValuation(valuationRequest: ValuationRequest): Promise<ValuationResponse> {
    return fetch(`${this.apiDomain}`, {
      body: JSON.stringify(valuationRequest),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        const errorResponse = new ValuationResponse();
        errorResponse.resultType = ValuationResultType.Error;

        return errorResponse;
      })
      .catch((error) => {
        console.log('There was an issue calling the Pricing API', error);
        const errorResponse = new ValuationResponse();
        errorResponse.resultType = ValuationResultType.Error;

        return errorResponse;
      });
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const vehicleValuationService = VehicleValuationLookupService.instance;
